module.exports = __webpack_public_path__ + "static/media/nike-oranje-fatalis.5210505b.jpg";